import { MiniBetSlipSchema } from './MiniBetSlip.styles';

export const miniBetSlipStyles: MiniBetSlipSchema = {
  wrapper: {
    mx: ['0', null, null, '-4'],
    bottom: '0',
    left: '0',
    position: ['fixed', null, null, 'sticky'],
    right: '0',
    zIndex: 'sticky',
    bg: 'alpha.500',
    borderBottomRadius: 'md',
  },
  slideBox: {
    bg: 'blackAlpha.400',
    color: 'gamma.200',
    mb: ['0', null, null, '-4'],
    borderTopWidth: '3px',
    borderTopColor: 'gamma.500',
    borderBottomRadius: 'md',
  },
  accordionItem: {
    bg: '#5b2cb8',
    borderTop: '3px',
    borderColor: 'gamma.500',
    borderTopWidth: '0',
    _last: {
      borderBottomWidth: '0',
    },
  },
  accordionHeaderText: {
    bg: 'transparent',
  },
  accordionButton: {
    fontSize: 'sm',
    fontWeight: 'normal',
    gap: '1',
    px: '4',
    py: '3',
    fontFamily: 'Staatliches',
    textTransform: 'uppercase',
    color: 'gamma.400',
    borderTop: '3px',
    borderColor: 'gamma.400',
    bg: 'blackAlpha.400',
  },
  accordionButtonIcon: {
    fontSize: 'sm',
  },
  buttonsHStack: {
    gap: '0',
  },
  headerStack: {
    bg: 'alpha.800',
    borderRadius: 'base',
    bottom: '100%',
    fontSize: 'xs',
    fontWeight: 'medium',
    left: '50%',
    pos: 'absolute',
    px: '4',
    py: '2',
  },
  headerText: {
    flex: '1',
  },
  headerButton: {
    display: 'inline-flex',
    fontSize: 'xl',
    minW: '0',
  },
  accordionPanel: {
    color: 'white',
    bg: 'alpha.800',
    fontSize: 'xs',
    maxH: '32',
    overflow: 'auto',
    p: '0',
  },
  selectionFlex: {
    borderColor: 'rgba(0, 0, 0, 0.10)',
    bg: 'alpha.900',
    gap: '2',
    p: '2',
    pos: 'relative',
    _notFirst: {
      borderTopStyle: 'dotted',
      borderTopWidth: '1px',
    },
    _before: {
      border: 'inherit',
      borderColor: 'whiteAlpha.300',
      content: '""',
      h: '1px',
      left: '0',
      pos: 'absolute',
      right: '0',
      top: '0',
    },
  },
  selectionMarketName: {
    flex: '1',
    fontWeight: 'bold',
  },
  selectionPropositionName: {
    flex: ['1', null, '2', null, '3'],
  },
  footerStack: {
    bg: 'blackAlpha.400',
    direction: 'row',
    fontSize: 'sm',
    fontWeight: 'semibold',
    py: '2.5',
    px: '4',
    pos: 'relative',
    borderTopColor: 'blackAlpha.300',
    borderBottomRadius: 'base',
    boxShadow: '0px 1px 0px 0px rgba(255, 255, 255, 0.15) inset',
    _before: {
      opacity: '0.2',
      bottom: 'calc(100% + 1px)',
      content: '""',
      h: '4',
      left: '0',
      pointerEvents: 'none',
      pos: 'absolute',
      right: '0',
      transitionDuration: 'normal',
      transitionProperty: 'common',
    },
  },
  footerHStack: {
    flex: '1',
  },
  legsText: {
    flex: '1',
    display: 'flex',
    flexDirection: 'column',
    color: 'gamma.200',
    fontWeight: 'extrabold',
    textTransform: 'uppercase',
    fontSize: '2xs',
  },
  legsChunks: {
    color: 'gamma.400',
    fontFamily: 'Staatliches',
    fontSize: '2xl',
    fontWeight: 'normal',
  },
  oddsText: {
    color: 'white',
    textTransform: 'uppercase',
    flex: '3',
    display: 'flex',
    fontWeight: 'bold',
    flexDirection: 'column',
    fontSize: '2xs',
  },
  oddsSkeletonLoader: {
    display: 'inline-block',
    ml: '1',
    w: '8',
  },
  oddsChunks: {
    color: 'gamma.400',
    fontFamily: 'Staatliches',
    fontSize: '2xl',
    fontWeight: 'normal',
  },
  clearButton: {
    variant: 'outline',
  },
  addToSlipButton: {
    variant: 'solid',
    fontSize: 'sm',
    px: '3',
    color: 'gamma.400',
  },
};
